import React from 'react';

interface PageContainerProps {
  children: React.ReactNode;
  title?: string;
  description?: string;
  className?: string;
  headerActions?: React.ReactNode;
  fullWidth?: boolean;
}

export function PageContainer({ 
  children, 
  title, 
  description, 
  className = '', 
  headerActions,
  fullWidth = false 
}: PageContainerProps) {
  return (
    <div className={`py-8 ${className} ${fullWidth ? 'sm:px-6 lg:px-8' : 'container mx-auto px-4 sm:px-6 lg:px-8'}`}>
      {(title || description || headerActions) && (
        <div className={`mb-8 ${fullWidth ? 'sm:px-6 lg:px-8' : ''}`}>
          <div className="flex items-center justify-between">
            <div>
              {title && (
                <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
              )}
              {description && (
                <p className="text-gray-600 mt-2">{description}</p>
              )}
            </div>
            {headerActions && (
              <div className="flex items-center space-x-4">
                {headerActions}
              </div>
            )}
          </div>
        </div>
      )}
      <div className={fullWidth ? 'px-4 sm:px-6 lg:px-8' : ''}>
        {children}
      </div>
    </div>
  );
} 